define([
    "dojo/_base/lang",
    "dojo/i18n!l10n/nls/toolstrip",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/DisplayStateProperty",
    "../properties/DndEnabledProperty"

],
    function (lang, toolstripL10n, TypeConstants, TypeProperty, TagProperty, DisplayStateProperty, DndEnabledProperty) {
        var hash = {};

        hash[TypeConstants.GALLERY_FAVORITE_CATEGORY] = lang.mixin({}, {
            title: {
                type: "string",
                notInAction: true,
                required: false,
                defaultValue: toolstripL10n.favoritesCategoryTitle
            }
        }, TypeProperty, TagProperty, DisplayStateProperty, DndEnabledProperty);

        return hash;
    });

